module.exports = __webpack_public_path__ + "img/charter-3.d31ffc9.png";